import AxiosClient from "../../services/axios.services";

class JobpositionRelatedServices {
  getJobpositionRelated = (params) =>
    AxiosClient.get("/api/app/Funcional_Puesto_Configuracion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  // getJobpositionRelatedById = (id) =>
  //   AxiosClient.get(`/api/app/Funcional_Puesto_Configuracion/${id}/`, {
  //     headers: { "Content-Type": "application/json" },
  //   });
  saveJobpositionRelated = (data) =>
    AxiosClient.post("/api/app/Funcional_Puesto_Configuracion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editJobpositionRelated = (id, data) =>
    AxiosClient.put(`/api/app/Funcional_Puesto_Configuracion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteJobpositionRelated = (id) =>
    AxiosClient.delete(`/api/app/Funcional_Puesto_Configuracion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new JobpositionRelatedServices();
